import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

const baseUrl = publicRuntimeConfig.rsvDashboardUrl || '';

export const siteUrl = `${baseUrl}/dashboard/site`;
